import { render, staticRenderFns } from "./CmsPage.vue?vue&type=template&id=60f50f4a&scoped=true"
import script from "./CmsPage.vue?vue&type=script&lang=js"
export * from "./CmsPage.vue?vue&type=script&lang=js"
import style0 from "./CmsPage.vue?vue&type=style&index=0&id=60f50f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f50f4a",
  null
  
)

export default component.exports